/* src/app/app.component.scss */
mat-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 99999;
}
.backdrop {
  margin-top: -20px;
  min-height: calc(100vh - 84px);
  background-size: cover;
  background-position: center;
  background-image: url("./media/backdrop.png");
}
.light-gray {
  background: #f0f0f0 !important;
}
mat-sidenav-container {
  min-height: 100vh;
  background: transparent;
}
mat-sidenav-container mat-sidenav {
  min-width: 300px;
  padding-top: 50px;
}
@media screen and (max-width: 400px) {
  mat-sidenav-container mat-sidenav {
    min-width: 100vw;
  }
}
mat-sidenav-container mat-sidenav .close-button {
  position: absolute;
  right: 10px;
  top: 10px;
}
mat-sidenav-container mat-sidenav .child {
  font-size: 0.9rem;
  background: rgba(0, 0, 0, 0.05);
}
mat-sidenav-container .container-gutter {
  padding-left: 15px;
  padding-right: 15px;
  max-width: 100% !important;
}
mat-sidenav-container mat-sidenav-content mat-toolbar {
  background-color: white;
  z-index: 1000;
  max-width: 100vw;
  box-shadow:
    0px 2px 4px -1px rgba(0, 0, 0, 0.06),
    0px 4px 5px 0px rgba(0, 0, 0, 0.042),
    0px 1px 10px 0px rgba(0, 0, 0, 0.036);
  margin-bottom: 20px;
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row {
  max-width: 1400px;
  margin: 0 auto;
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row {
  margin-top: 10px;
  margin-bottom: 10px;
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row .logo img {
  height: 34px;
  display: block;
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row button.user-menu {
  padding: 0;
}
@media screen and (min-width: 400px) {
  mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row button.user-menu {
    padding: 0 16px;
  }
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row button.user-menu .profile-picture {
  vertical-align: middle;
  margin-left: 10px;
  display: inline-block;
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row button.user-menu .member-name {
  display: none;
}
@media screen and (min-width: 400px) {
  mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.first-row button.user-menu .member-name {
    display: inline-block;
  }
}
mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.second-row {
  margin-top: -20px;
  display: none;
}
@media screen and (min-width: 400px) {
  mat-sidenav-container mat-sidenav-content mat-toolbar mat-toolbar-row.second-row {
    display: flex;
  }
}
mat-sidenav-content {
  min-height: 100vh;
  max-width: 100vw;
}
.offline-notice {
  position: sticky;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  line-height: 50px;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.85);
  text-align: center;
}
.offline-notice p {
  color: white;
  line-height: 50px;
}
.external-button {
  text-decoration: none;
}
.weapon {
  margin-left: auto;
  margin-right: 20px;
  width: 80px;
}
/*# sourceMappingURL=app.component.css.map */
